module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-dialog', {
    staticClass: "photos-dialog",
    attrs: {
      "title": "Zdjęcia",
      "append-to-body": "",
      "before-close": _vm.handleClose,
      "width": "80vw",
      "visible": _vm.dialogFormVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormVisible = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.searchData($event)
      }
    }
  }, [_c('el-form-item', {
    staticClass: "list__search-wrapper"
  }, [_c('el-input', {
    staticClass: "list__search",
    attrs: {
      "placeholder": "Nazwa"
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "list__search-wrapper"
  }, [_c('el-button', {
    on: {
      "click": _vm.searchData
    }
  }, [_vm._v(_vm._s(_vm.$t('search')))])], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "list"
  }, _vm._l((_vm.photos), function(photo) {
    return _c('el-card', {
      key: ((photo.photo) + "_" + (photo.name_pl) + "_" + (photo.title_pl)),
      staticClass: "item",
      attrs: {
        "shadow": "hover",
        "body-style": {
          padding: '0px'
        }
      }
    }, [_c('div', {
      on: {
        "click": function($event) {
          return _vm.submitPhoto(photo.photo)
        }
      }
    }, [_c('img', {
      staticClass: "item__img",
      attrs: {
        "src": photo.photo,
        "alt": ""
      }
    }), _vm._v(" "), (photo.name_pl || photo.title_pl) ? _c('p', {
      staticClass: "item__text"
    }, [_vm._v("\n                        " + _vm._s(_vm.truncate(photo.name_pl || photo.title_pl)) + "\n                    ")]) : _vm._e()])])
  }), 1), _vm._v(" "), _c('el-col', {
    staticClass: "list__pagination",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "disabled": _vm.loading,
      "page-size": _vm.pageSize,
      "total": _vm.count
    },
    on: {
      "current-change": _vm.handlePageChange
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        return _vm.cancelForm()
      }
    }
  }, [_vm._v("Anuluj")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-01bf273a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PhotosDialog.vue
// module id = 709
// module chunks = 0